import { render, staticRenderFns } from "./JhyjDetail.vue?vue&type=template&id=19dff127&scoped=true"
import script from "./JhyjDetail.vue?vue&type=script&lang=js"
export * from "./JhyjDetail.vue?vue&type=script&lang=js"
import style0 from "./JhyjDetail.vue?vue&type=style&index=0&id=19dff127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dff127",
  null
  
)

export default component.exports